<script setup>
import {isProd} from "@/utils/constants"
</script>
<template>
    <div class="menu-container">
        <div class="menu-wrapper">
            <div class="menu-header">
                <div class="menu-logo-wrapper" v-if="isProd === true">
                    <img class="menu-logo-img" src="../images/logo.svg" alt="menu logo">
                    <img class="project-name-img" src="../images/page_name.svg" alt="project name">
                </div>
                <div v-else  class="menu-logo-wrapper-test">测试</div>
                <img class="close-btn" src="../images/close.svg" alt="close" @click="onCloseMenu">
            </div>

            <div class="menu-item" @click="onHeaderLabelClicked('HOME')">
                <div class="menu-text">{{localize('首页')}}</div>
            </div>
            <div class="menu-item" @click="onHeaderLabelClicked('PRESALE')">
                <div class="menu-text">{{localize('节点认购')}}</div>
            </div>
            <div class="menu-item" @click="onHeaderLabelClicked('ORDER')">
                <div class="menu-text">{{localize('订单记录')}}</div>
            </div>
            <div class="menu-item" @click="onHeaderLabelClicked('COMMUNITY')">
                <div class="menu-text">{{localize('我的社群')}}</div>
            </div>
            <div class="menu-item" @click="onHeaderLabelClicked('NFT')">
                <div class="menu-text">{{localize('NFT卡牌')}}</div>
            </div>
            <div class="menu-item" @click="onHeaderLabelClicked('RESONANCE')">
                <div class="menu-text">{{localize('参与共振流动性')}}</div>
            </div>
            <div class="menu-item" @click="onHeaderLabelClicked('ASSETS')">
                <div class="menu-text">{{localize('我的资产')}}</div>
            </div>

<!--            <div class="lang-btn-wrapper-mobile">-->
<!--                <div class="lang-container-mobile" ref="langBtnRef" @click="onLangBtnClick">-->
<!--                    <img class="lang-flag-icon-mobile" :src="currentLangSelection.icon" alt="lang">-->
<!--                    <div class="lang-text-mobile">{{ currentLangSelection.label }}</div>-->
<!--                    <img class="lang-arrow" src="../images/lang/arrow_down.svg" alt="arrow">-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>

    <Teleport to="body">
        <Transition name="dropdown">
            <div class="lang-menu-container-bg" @click="handleOutsideClick" v-if="isLangMenuOpen">
                <div
                    ref="menuRef"
                    class="lang-dropdown-menu"
                    :style="langMenuPosition">
                    <div v-for="(item, index) in langMenuItems"
                         :key="index"
                         class="lang-menu-item"
                         @click="selectLangItem(item)">
                        <img class="lang-menu-flag-icon" :src="item.icon" alt="flag">
                        <div class="lang-menu-text">{{ item.label }}</div>
                    </div>
                </div>
            </div>

        </Transition>
    </Teleport>
</template>
<script>
import cnLangIcon from '@/images/lang/lang_cn.svg'
import enLangIcon from '@/images/lang/lang_en.svg'
import {getLanguageStore} from '@/lang/langStore'

export default {
    name: 'HeaderComponent',
    props: {
        msg: String
    },
    mounted() {
        this.setupCurrentLang()
    },
    components: {},
    data() {
        return {
            langMenuItems: [
                {icon: cnLangIcon, label: '繁體中文', code: 'CN'},
                {icon: enLangIcon, label: 'EN', code: 'EN'}
            ],
            isLangMenuOpen: false,
            currentLangSelection: {
                icon: null, label: null
            },
            langMenuPosition: {
                top: '0px',
                left: '0px',
                zIndex: '1000',
                position: 'fixed'
            },
            currentSelected: 'PRESALE'
        }
    },
    computed: {
        getReferId() {
            if (this.$store.state.referId) {
                return this.$store.state.referId
            }

            const params = new URL(window.location.href).searchParams
            const referId = params.get('ref')
            this.$store.dispatch('setReferId', {
                referId: referId
            })
            return referId
        }
    },
    inject: ['langStore', 'localize'],
    methods: {
        onCloseMenu() {
            this.$emit('close')
        },
        onLangBtnClick() {
            this.isLangMenuOpen = true
            this.updateMenuPosition()
        },
        setupCurrentLang() {
            const currentLang = this.langStore.getCurrentLanguage.toUpperCase()
            if (currentLang === 'CN') {
                this.currentLangSelection = this.langMenuItems[0]
            } else {
                this.currentLangSelection = this.langMenuItems[1]
            }
        },
        updateMenuPosition() {

            if (!this.$refs.langBtnRef) return;

            const buttonRect = this.$refs.langBtnRef.getBoundingClientRect();

            // 设置菜单宽度与按钮相同
            this.$refs.langBtnRef.width = `${buttonRect.width}px`;

            // 菜单位置在按钮正下方
            this.langMenuPosition.top = `${buttonRect.bottom + window.scrollY}px`;
            this.langMenuPosition.left = `${buttonRect.left + window.scrollX}px`;
        },
        handleOutsideClick() {
            this.isLangMenuOpen = false
        },
        selectLangItem(item) {
            this.currentLangSelection = {
                icon: item.icon,
                label: item.label
            }

            getLanguageStore().setLanguage(item.code)
        },
        onHeaderLabelClicked(tag) {
            this.currentSelected = tag
            if (tag === 'HOME') {
                this.$router.push({ path: '/home', query: { ref: this.getReferId } });
                this.$emit('close')
                return
            }
            if (tag === 'PRESALE') {
                this.$router.push({ path: '/presale', query: { ref: this.getReferId } });
                this.$emit('close')
                return
            }
            if (tag === 'ORDER') {
                this.$router.push({ path: '/order', query: { ref: this.getReferId } });
                this.$emit('close')
                return
            }
            if (tag === 'COMMUNITY') {
                this.$router.push({ path: '/community', query: { ref: this.getReferId } });
                this.$emit('close')
                return
            }
            if (tag === 'NFT') {
                this.$router.push({ path: '/nft', query: { ref: this.getReferId } });
                this.$emit('close')
                return
            }
            if (tag === 'RESONANCE') {
                this.$router.push({ path: '/resonance', query: { ref: this.getReferId } });
                this.$emit('close')
                return
            }
            if (tag === 'ASSETS') {
                this.$router.push({ path: '/assets', query: { ref: this.getReferId } });
                this.$emit('close')
                return
            }
        },
    }
}
</script>
<style scoped>
.menu-container {
    background-color: #162312;
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    padding: 1em 2em;
    box-sizing: border-box;
}

.menu-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.close-btn {
    width: 2em;
    top: 0;
    right: 0;
    padding: 1em 0;
}

.menu-icon {
    width: 2.6em;
}

.menu-text {
    font-size: 2em;
    color: #ffffff;
    line-height: 2em;
}

.menu-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.menu-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.6em;
    padding: 1em 0;
    box-sizing: border-box;
    border-bottom: 1px solid #5e7656;
}

.menu-logo-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.6em;
}

.menu-logo-wrapper-test{
    color: #ffffff;
    font-size: 2.4em;
}

.menu-logo-img {
    width: 3em;
    padding: 1em 0;
    box-sizing: border-box;
}

.menu-logo-txt {
    color: #fff;
    font-size: 2.6em;
}

.lang-container-mobile {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0.4em;
    border-radius: 0.4em;
    cursor: pointer;
    margin-top: 2em;
    width: fit-content;
}

.lang-flag-icon-mobile {
    width: 2em;
    padding: 0 0.4em;
}

.lang-arrow {
    width: 1.4em;
    margin-left: 0.4em;
}

.lang-text-mobile {
    font-size: 1.6em;
    line-height: 1.6em;
    color: #ffffff;
}

.lang-btn-wrapper-mobile {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.lang-menu-container-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 999;
}

.lang-dropdown-menu {
    border-radius: 0.4em;
    display: flex;
    flex-direction: column;
    gap: 0.4em;
    background-color: #ffffff;
    filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.3));
}

.lang-menu-item {
    font-size: 2em;
    color: #000000;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #ffffff;
    padding: 0.2em 0.4em;
    gap: 0.4em;
    cursor: pointer;
}

.lang-menu-item:hover {
    background-color: #d9d9d9;
}

.lang-menu-flag-icon {
    width: 0.6em;
}

.lang-menu-text {
    font-size: 0.6em;
    color: #656565;
    flex: 1;
}


/* 过渡：右侧滑入/滑出 */
.slide-right-enter-from,
.slide-right-leave-to {
    transform: translateX(100%);
}
.slide-right-enter-to,
.slide-right-leave-from {
    transform: translateX(0);
}
.slide-right-enter-active,
.slide-right-leave-active {
    transition: transform 0.26s ease-in-out;
}

.project-name-img{
    height: 2.4em;
}
</style>